/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} DarkInputs */

const en_dark = /** @type {(inputs: DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dark`)
};

const fr_dark = /** @type {(inputs: DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sombre`)
};

const de_dark = /** @type {(inputs: DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dunkel`)
};

const it_dark = /** @type {(inputs: DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buio`)
};

const ru_dark = /** @type {(inputs: DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Темный`)
};

const es_dark = /** @type {(inputs: DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oscuro`)
};

const zh_cn2_dark = /** @type {(inputs: DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`黑暗的`)
};

const ja_dark = /** @type {(inputs: DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暗い`)
};

const hi_dark = /** @type {(inputs: DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अँधेरा`)
};

const pt_pt2_dark = /** @type {(inputs: DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escuro`)
};

/**
* | output |
* | --- |
* | "Dark" |
*
* @param {DarkInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dark = /** @type {((inputs?: DarkInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<DarkInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dark(inputs)
	if (locale === "de") return de_dark(inputs)
	if (locale === "it") return it_dark(inputs)
	if (locale === "ru") return ru_dark(inputs)
	if (locale === "es") return es_dark(inputs)
	if (locale === "zh-CN") return zh_cn2_dark(inputs)
	if (locale === "ja") return ja_dark(inputs)
	if (locale === "hi") return hi_dark(inputs)
	if (locale === "pt-PT") return pt_pt2_dark(inputs)
	return en_dark(inputs)
});